export default __webpack_public_path__ + "static/media/home_page_logo.8f4b2e29.png";